module.exports = __webpack_public_path__ + "static/media/sandigo-logo.b4efe991.jfif";